import { Record, List } from 'immutable';

const defaultValues = {
  id: 0,
  type: '',
  textKey: '',
  name: '',
  description: '',
  abbreviation: '',
  keyValue: '',
  ordinal: 0,
  emaiId: '',
  locale: '',
  typeItemId: null,
  typeItemName: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  postalCode: '',
  countryCode: '',
  areaCode: '',
  subscriber: '',
  urlAddress: '',
};

export default class Organization extends Record(defaultValues, Organization) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static removeEmptyTextKeys(organizations) {
    return organizations.filter((item) => {
      return item.get('textKey').length === 3;
    });
  }
}

export const Organizations = (data) => {
  let organizations = new List();
  if (data) {
    data.forEach((value) => {
      organizations = organizations.push(new Organization(value));
    });
  }
  return organizations;
};
